// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dm6wo","col":"styles_col__2bXJJ"};